import { Spinner } from '@frontend/elements';
import { Application } from '@frontend/functionality/types';
import { FormattedMessage } from 'react-intl';

import { Action } from './action/action.component';
import useQuickActions from './quick-actions.controller';

export interface QuickActionsProps {
    application?: Application | 'my';
    orientation?: 'horizontal' | 'vertical';
    /** When true, renders the Shortcuts heading above the actions (home pages). */
    includeHeading?: boolean;
}

export const QuickActions = (props: QuickActionsProps) => {
    const viewProps = useQuickActions(props);

    if (!props.application) return null;
    if (viewProps.isLoading) {
        return props.includeHeading ? null : <Spinner />;
    }
    if (!viewProps.relevantFunctionalities?.length) return null;

    const actions =
        props.orientation === 'vertical' ? (
            <div className='inline-flex flex-col justify-start gap-4 self-stretch'>
                {viewProps.relevantFunctionalities.map((functionality) => (
                    <Action
                        key={functionality.id}
                        functionality={functionality}
                        application={props.application!}
                        fullWidth
                    />
                ))}
            </div>
        ) : (
            <div className='no-scrollbar -mx-5 inline-flex w-screen items-start justify-start gap-3 overflow-x-scroll ps-5 pe-5'>
                {viewProps.relevantFunctionalities.map((functionality) => (
                    <Action
                        key={functionality.id}
                        functionality={functionality}
                        application={props.application!}
                    />
                ))}
            </div>
        );

    if (!props.includeHeading) return actions;

    return (
        <div className='flex w-full flex-col gap-3'>
            <div className='flex w-full justify-between'>
                <div className='text-foreground-default justify-start font-medium'>
                    <FormattedMessage
                        id='home.shortcuts'
                        defaultMessage='Shortcuts'
                        description='Shortcuts'
                    />
                </div>
            </div>
            <div className='min-h-fit w-full'>{actions}</div>
        </div>
    );
};
